var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgExit(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "20px",
    height: "20px",
    viewBox: "0 0 20 20",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "Icons/exit") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Symbols",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Icons/exit"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M10,1 C5.032,1 1,5.032 1,10 C1,14.968 5.032,19 10,19 C14.968,19 19,14.968 19,10 C19,5.032 14.968,1 10,1 Z",
    id: "Path",
    fill: "#191E1E",
    fillRule: "nonzero"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group-3",
    transform: "translate(5.518875, 5.372762)",
    stroke: "#FFFFFF",
    strokeWidth: 1.5
  }, /*#__PURE__*/React.createElement("line", {
    x1: -1.40380592,
    y1: 4.59619408,
    x2: 10.5961941,
    y2: 4.59619408,
    id: "Path-4",
    transform: "translate(4.596194, 4.596194) rotate(-315.000000) translate(-4.596194, -4.596194) "
  }), /*#__PURE__*/React.createElement("line", {
    x1: 4.59619408,
    y1: -1.40380592,
    x2: 4.59619408,
    y2: 10.5961941,
    id: "Path-4",
    transform: "translate(4.596194, 4.596194) rotate(-315.000000) translate(-4.596194, -4.596194) "
  }))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgExit);
export default __webpack_public_path__ + "static/media/Exit.a7e81691c8287518e4dd9fb3642a90c8.svg";
export { ForwardRef as ReactComponent };